import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import AuthContext from '../../AuthContext';
import InvoiceViewer from './InvoiceViewer';
import { Menu, Paper } from '@mantine/core';

const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const { centre, userType } = useContext(AuthContext);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(value);
  };

  const columns = useMemo(
    () => {
      const commonColumns = [
        { accessorKey: 'invoice_no', header: 'Invoice Id' },
        { accessorKey: 'scheme_name', header: 'Scheme Name' },
        { accessorKey: 'milestone', header: 'Milestone' },
        { accessorKey: 'gross_amount', header: 'Gross Amount', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        { accessorKey: 'tds_amount', header: 'TDS Amount', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        { accessorKey: 'penal_deduction', header: 'Penal Deduction', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        {
          accessorKey: 'created_date',
          header: 'Created Date',
          Cell: ({ cell }) => formatDate(cell.getValue()),
        },
        { accessorKey: 'status', header: 'Status' },
        { accessorKey: 'net_payment', header: 'Net Payment', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        { accessorKey: 'book', header: 'Book', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        { accessorKey: 'kit', header: 'Kit', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        {
          accessorKey: 'centre_share',
          header: 'Centre Share',
          //Cell: ({ cell }) => formatPercentage(cell.getValue()),
        },
        { accessorKey: 'tds', header: 'Centre TDS', Cell: ({ cell }) => formatCurrency(cell.getValue()) },
        { accessorKey: 'after_tds', header: 'After TDS', Cell: ({ cell }) => formatCurrency(cell.getValue()) },

        {
          accessorKey: 'received_date',
          header: 'Received Date',
          Cell: ({ cell }) => {
            const value = cell.getValue();
            return value ? formatDate(value) : 'N/A'; // If value is null, undefined, or empty string, display 'N/A'
          }
        }

      ];

      if (userType === 'Superadmin' || userType === 'Accounts') {
        return [
          { accessorKey: 'centre_name', header: 'Centre Name' },
          { accessorKey: 'vtp_id', header: 'VTP ID' },
          ...commonColumns,
        ];
      }

      return commonColumns;
    },
    [userType]
  );

  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    axios
      .post('/invoice/getAll', {

        centre_id: centre,

      })
      .then((res) => {
        setData(res.data)
       // console.log(res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate, centre, userType]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        {(userType === 'Superadmin' || userType === 'Accounts') && <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>}
        <InvoiceViewer invoice={row.original} />
      </>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div style={{ width: '100%' }}>

        <MantineReactTable
          table={table}
          striped // Enables the striped rows
          highlightOnHover
          horizontalSpacing="md"
          verticalSpacing="sm"
          fontSize="sm"
          withColumnBorders
          borderRadius="md"
          withGlobalFilter
          height={400}
          rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
          enablePagination={true} // Enables pagination
        />
      </div>
    </Paper>
  );
};

export default Example;
